import api from "./axios";

const BASE = "/api/v1/admin/provider-verifications";

export async function getProviderVerificationSummary() {
  const res = await api.get(`${BASE}/summary`);
  return res.data;
}

export async function listProviderVerifications({
  status = "PENDING_REVIEW",
  q = "",
  page = 0,
  size = 20,
} = {}) {
  const res = await api.get(BASE, {
    params: { status, q, page, size },
  });
  return res.data;
}

export async function getProviderVerificationDetail(providerId) {
  const res = await api.get(`${BASE}/${providerId}`);
  return res.data;
}

export async function approveProviderVerification(providerId, notes) {
  const res = await api.post(`${BASE}/${providerId}/approve`, { notes });
  return res.data;
}

export async function rejectProviderVerification(providerId, reason, notes) {
  const res = await api.post(`${BASE}/${providerId}/reject`, { reason, notes });
  return res.data;
}

export async function requestProviderVerificationDocuments(
  providerId,
  documentTypes,
  message,
  notes,
) {
  const res = await api.post(`${BASE}/${providerId}/request-documents`, {
    documentTypes,
    message,
    notes,
  });
  return res.data;
}
